import React, { useState, useEffect, useRef, useCallback } from "react";
// import TimeDifference from "../components/features/TimeDifference";
import { useSelector } from "react-redux";
import ChatItem from "../components/features/ChatItem";
import { fetchLocutorName } from "./FetchUpdateUserData";
import message from "./../assets/audio/message.mp3";
import send from "./../assets/audio/send.mp3";
import cancel from "./../assets/audio/cancel.mp3";
import connect from "./../assets/audio/connect.mp3";
import { useTranslation } from "react-i18next";
import { Link, Navigate } from "react-router-dom";
import Popup from "../components/common/Popup";
import { checkMoney, checkWalletsType } from "../utils/configData";
import { ViewDetails } from "../components/features/ViewDetails";
import { useDropzone } from 'react-dropzone';
import { registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginImagePreview);

const Chat = ({ chatID, chatData, sellWalletData, buyWalletData, chatToken }) => {
  const userInfo = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [socket, setSocket] = useState(null);
  const textareaRef = useRef(null);
  const [status, setStatus] = useState(
    chatData.status === 0 && userInfo.type === 1 ? 1 : chatData.status
  );
  const [value, setValue] = useState("");
  const [invoice, setInvoice] = useState(null);
  const { t } = useTranslation();
  const [interlocutorFName, setInterlocutorFName] = useState("CryptoHub");
  const [interlocutorLName, setInterlocutorLName] = useState(null);
  const [changeStatus, setChangeStatus] = useState(handleStatus(status));
  const [isPopupOpenView, setIsPopupOpenView] = useState(false);
  const currencySellData = checkMoney(chatData.sell_currency);
  const currencyBuyData = checkMoney(chatData.buy_currency);

  // Filepond
  const onDrop = useCallback((acceptedFiles) => {
    // Додаємо нові файли до існуючого списку файлів
    setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noClick: true // Запобігає відкриттю вікна вибору файлів при кліку 
  });

  const hiddenFileInput = useRef(null);
  // Функція для відкриття діалогу вибору файлів при кліку
  const handleFile = () => {
    hiddenFileInput.current.click();
  };

  const [files, setFiles] = React.useState([]);
  const [attachmentHeight, setAttachmentHeight] = useState(0)
  const [inputHeight, setInputHeight] = useState(0)
  const attachmentRef = useRef(null);
  // useEffect(() => { console.log("file", files) }, [files]);

  useEffect(() => {
    const handlePaste = (event) => {
      const files = Array.from(event.clipboardData.files);
      if (files.length > 0) {
        setFiles((prevFiles) => [...prevFiles, ...files]);
      }
    };

    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, []);


  useEffect(() => {
    if (attachmentRef.current && textareaRef.current) {
      setAttachmentHeight(attachmentRef.current.offsetHeight);
      setInputHeight(textareaRef.current.offsetHeight);
    }
  }, [files, value]);


  const deleteFile = (index) => {
    setFiles(files.filter((_, i) => i !== index))
  }

  //   useEffect(() => {
  //   // Fetch initial messages and add timestamps
  //   const fetchInitialMessages = async () => {
  //     // Replace this with your actual API call to fetch initial messages
  //     const initialMessages = await fetchMessagesFromAPI(chatID); // Replace with your API call

  //     const messagesWithTimestamps = initialMessages.map(message => ({
  //       ...message,
  //       timestamp: new Date(message.createdAt).getTime() // Assuming each message has a createdAt field
  //     }));

  //     setData(messagesWithTimestamps.sort((a, b) => b.timestamp - a.timestamp));
  //   };

  //   fetchInitialMessages();
  // }, [chatID]);

  useEffect(() => {
    if (chatData.manager === userInfo.id || userInfo.type === 0 || chatData.manager === null) {

      const ws = new WebSocket(
        `wss://${chatData.name.slice(
          0,
          2
        ).toLowerCase()}.cryptohub.exchange/${chatData.name.slice(
          0,
          2
        ).toLowerCase()}/chat/${chatID}/connect`
      );

      const token = chatToken;


      // Встановлення обробників подій
      ws.onopen = () => {
        ws.send(token);
        console.log("WebSocket Connected", token);
      };
      const audio = new Audio(message);
      const audioSend = new Audio(send);
      const audioCancel = new Audio(cancel);
      const audioConnect = new Audio(connect);
      ws.onmessage = (event) => {
        if (event.data instanceof Blob) {
          // Якщо дані у форматі Blob, ми спочатку конвертуємо їх у ArrayBuffer
          const reader = new FileReader();
          reader.onload = function () {
            const arrayBuffer = reader.result;
            const view = new DataView(arrayBuffer);
            const identifier = view.getUint8(0);
            const type = view.getUint8(1);
            if (identifier === 1) {
              setStatus(status > type ? status : type);
              if (type === 1) {
                audioConnect.play();
              } else if (type === 2) {
                audioSend.play();
              } else if (type === 4) {
                audioCancel.play();
              }
            }

            if (identifier === 0) {
              if (identifier === 0 && type !== userInfo.type) {
                audio.play();
              }

              const timestamp = Date.now(); // Add timestamp to each message

              if (view.getUint8(2) === 0) {
                const blob = new Blob([arrayBuffer.slice(5)]);
                const textReader = new FileReader();
                textReader.onload = function () {
                  setData((prev) => [
                    { text: textReader.result, type: type, timestamp },
                    ...prev,
                  ].sort((a, b) => b.timestamp - a.timestamp));
                };
                textReader.readAsText(blob);
              }

              if (view.getUint8(2) === 1) {
                const fileCount = view.getUint8(3);
                const textLength = view.getUint8(4);

                const textBlob = new Blob([arrayBuffer.slice(5, 5 + textLength)]);
                const urlBlob = new Blob([arrayBuffer.slice(5 + textLength)]); // Відокремлення тексту та URL
                const textReader = new FileReader();
                const urlReader = new FileReader(); // Створення окремого FileReader для URL

                textReader.onload = function () {
                  const decodedText = textReader.result; // Повний текст, що зчитано

                  urlReader.onload = function () {
                    const decodedURLs = urlReader.result; // Повні URL, що зчитано
                    let urls = [];
                    let start = 0; // Початок URL блоку в decodedURLs

                    for (let i = 0; i < fileCount; i++) {
                      const urlLength = view.getUint8(5 + textLength + start);
                      console.log(`URL Length: ${urlLength}`); // Логування довжини URL
                      const url = decodedURLs.slice(start + 1, start + 1 + urlLength);
                      urls.push(url);
                      start += urlLength + 1; // Оновлення start для наступного URL
                      console.log(`Next start: ${start}`); // Логування нового старту
                    }

                    setData(prev => [
                      { text: decodedText, fileURL: urls, type: type, timestamp },
                      ...prev,
                    ].sort((a, b) => b.timestamp - a.timestamp));
                    console.log("URLs", urls); // Вивід URL
                  };

                  urlReader.readAsText(urlBlob); // Зчитування URL
                };

                textReader.readAsText(textBlob); // Зчитування текстової частини
              }


            } else if (identifier === 1 && type === 1) {
              // При отриманні повідомлення про зміну статусу і підключені менеджера до чату, створюється запит на отримання імені співрозмовника
              const blob = new Blob([arrayBuffer.slice(2)]);
              const textReader = new FileReader();
              textReader.onload = function () {
                fetchLocutorName(
                  userInfo.type === 1 ? chatData.user : textReader.result
                ).then((response) => {
                  if (response) {
                    setInterlocutorFName(response.fname);
                    setInterlocutorLName(response.lname);
                  }
                });
              };
              textReader.readAsText(blob);
            } else if (identifier === 2 && type === 0) {
              setInvoice(true);
            }
          };
          reader.readAsArrayBuffer(event.data);
        }
      };

      ws.onerror = (error) => {
        console.log("WebSocket Error ", error);
      };

      ws.onclose = () => {
        setSocket("Disconnected");
      };

      setSocket(ws);

      return () => {
        ws.close();
      };

    }

  }, []);

  const heightTextArea = (a) => {
    const textarea = textareaRef.current;
    if (a) {
      textarea.style.height = `${a + Number(textarea.style.height.slice(0, -2))
        }px`;
      console.log(`${a + Number(textarea.style.height.slice(0, -2))}px`);
    } else {
      if (textarea.scrollHeight === 28) {
        textarea.style.height = "24px";
        return;
      } else {
        textarea.style.height = "24px"; // Скидаємо висоту перед визначенням нової висоти
        textarea.style.height = `${textarea.scrollHeight}px`; // Задаємо висоту за розміром вмісту
      }
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
    heightTextArea();
  };

  const handleSubmit = (e, currentValue = value, currentFiles = files) => {
    e.preventDefault();
    console.log("Attempting to send message");

    const maxSizeValue = currentValue.substring(0, 249); // Перші 249 символів
    const remainingValue = currentValue.substring(249);

    if (maxSizeValue === "" && currentFiles.length === 0) {
      console.warn("Message is empty, nothing to send");
      return;
    }

    const encoder = new TextEncoder();
    const now = new Date().toISOString().substring(11, 16);
    const encodedTime = encoder.encode(now);
    const encodedString = encoder.encode(maxSizeValue);

    let filesSize = 0;
    let filesExtensionSize = 0;

    currentFiles.forEach((file) => {
      filesSize += file.size;
      const extension = file.name.split('.').pop();
      filesExtensionSize += extension.length;
    });

    const buffer = new ArrayBuffer(   // Загальний розмір буфера
      4 + encodedTime.length + encodedString.length + (currentFiles.length * 5) + filesExtensionSize + filesSize
    );

    const view = new Uint8Array(buffer);
    view[0] = 0; // індифікатор повідомлення

    if (currentFiles.length > 0) { // чи є файл в повідомленні
      view[1] = 1;
      view[2] = currentFiles.length;
    } else {
      view[1] = 0;
      view[2] = 0;
    }

    view[3] = encodedTime.length + encodedString.length;
    const totalFileSizeBuffer = new ArrayBuffer(4); // 4 байти для Int32 сука
    const totalFileSizeView = new DataView(totalFileSizeBuffer);
    totalFileSizeView.setInt32(0, filesSize, false); // Запис довжини не в little-endian
    view.set(encodedTime, 4);
    view.set(encodedString, 4 + encodedTime.length);
    // view.set(new Uint8Array(totalFileSizeBuffer), 4 + encodedTime.length + encodedString.length);

    let offset = 4 + encodedTime.length + encodedString.length;
    function readFileAndAppend(file, offset) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const fileBuffer = reader.result; // `result` буде типу ArrayBuffer
          const fileView = new Uint8Array(fileBuffer);
          const lengthBuffer = new ArrayBuffer(4); // 4 байти для Int32
          const lengthView = new DataView(lengthBuffer);
          lengthView.setInt32(0, fileView.length, false); // Записуємо довжину в little-endian форматі
          view.set(new Uint8Array(lengthBuffer), offset);
          offset += 4;
          const fileName = file.name;
          const fileExtension = fileName.split('.').pop();
          const encodedExtension = encoder.encode(fileExtension);
          view.set(Uint8Array.of(encodedExtension.length), offset);
          console.log("Extension length)", Uint8Array.of(encodedExtension.length));
          offset += 1;
          view.set(encodedExtension, offset);
          console.log("306", offset);
          offset += encodedExtension.length;
          view.set(fileView, offset);
          console.log("310", offset);
          offset += fileView.length;
          resolve(offset);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
        // console.log("reader", reader.readAsArrayBuffer(file));
      });
    }
    async function processFiles(currentFiles) {
      let currentOffset = offset;
      for (let i = 0; i < currentFiles.length; i++) {
        currentOffset = await readFileAndAppend(currentFiles[i], currentOffset);
      }
      if (socket && socket.readyState === WebSocket.OPEN) {
        console.log("view", view);
        socket.send(view);
        console.log("Message sent successfully", view);
        if (remainingValue.length > 0) {
          return handleSubmit(e, remainingValue, [])
        }
      } else {
        console.error("WebSocket is not open");
      }

      setValue("");
      setFiles([]);
      textareaRef.current.style.height = "24px";
      console.log("Message processed");
    }

    processFiles(currentFiles);
  };

  const handleConfirm = (e) => {
    const buffer = new ArrayBuffer(2);
    const view = new Uint8Array(buffer);
    if (userInfo.type === 0) {
      view[0] = 1;
      view[1] = 2;
    } else if (userInfo.type === 1) {
      view[0] = 1;
      view[1] = 3;
    }

    socket.send(view);
    console.log("Message sent successfully");
  };

  const handleCancel = (e) => {
    const buffer = new ArrayBuffer(2);
    const view = new Uint8Array(buffer);
    view[0] = 1;
    view[1] = 4;

    socket.send(view);
    console.log("Message sent successfully");
  };

  useEffect(() => {
    if (chatData.manager || (userInfo.type === 1 && chatData.user)) {
      fetchLocutorName(
        userInfo.type === 1 ? chatData.user : chatData.manager
      ).then((response) => {
        if (response) {
          setInterlocutorFName(response.fname);
          setInterlocutorLName(response.lname);
        }
      });
    }
  }, [chatData.manager, chatData.user, userInfo.type]);


  function handleStatus(e) {
    if (e === 0) {
      return "Matching";
    } else if (e === 1) {
      return "Pending";
    } else if (e === 2) {
      return "Reviewing";
    } else if (e === 3) {
      return "Fulfilled";
    } else if (e === 4) {
      return "Cancelled";
    }
  }

  useEffect(() => {
    setChangeStatus(handleStatus(status));
  }, [status]);

  const hotKeys = (e) => {
    if (e.key === "Enter" && !e.ctrlKey) {
      handleSubmit(e); // Викликати функцію обробки відправки форми
    } else if (e.key === "Enter" && e.ctrlKey) {
      // Дозволяємо Ctrl+Enter створювати новий рядок
      e.preventDefault();
      const newValue = value + "\n";
      setValue(newValue);
      heightTextArea(24);
    }
  };

  const [isPopupOpenCanceled, setIsPopupOpenCanceled] = useState(false);
  const closePopupCanceled = () => {
    setIsPopupOpenCanceled(false);
  };

  const [isPopupOpenConfirm, setIsPopupOpenConfirm] = useState(false);
  const closePopupConfirm = () => {
    setIsPopupOpenConfirm(false);
  };

  function convertTRCIdentifiers(input) {
    return input.replace(/trc(\d+)/gi, (match, number) => `(TRC-${number})`);
  }

  if (socket === "Disconnected") {
    return <Navigate to="/transactions-list" />;
  }
  if (
    // (userInfo.id !== chatData.manager &&
    //   userInfo.type === 1 &&
    //   chatData.manager !== null) ||
    (userInfo.id !== chatData.user && userInfo.type === 0)
  ) {
    return <Navigate to="/transactions-list" />;
  }

  const checkFormatFile = (file) => {
    const fileName = file.name;

    // Отримання розширення файлу
    const fileExtension = fileName.split('.').pop();
    switch (fileExtension) {

      case "png":
        return "image"
      case "jpeg":
        return "image"
      case "jpg":
        return "image"
      case "gif":
        return "image"
      case "bmp":
        return "image"
      case "tiff":
        return "image"
      case "tif":
        return "image"
      case "psd":
        return "image"
      case "webp":
        return "image"
      case "heic":
        return "image"
      case "heif":
        return "image"
      case "raw":
        return "image"
      case "cr2":
        return "image"
      case "nef":
        return "image"
      case "orf":
        return "image"
      case "sr2":
        return "image"
      case "ico":
        return "image"
      case "svg":
        return "image"
      case "ai":
        return "image"
      case "eps":
        return "image"
      default:
        return "file"
    }

  }


  return (
    <div className="chat">
      <Popup isOpen={isPopupOpenCanceled} onClose={closePopupCanceled}>
        <div className="view-details">
          <button onClick={closePopupCanceled} className="close-popup">
            <i className="ri-close-line"></i>
          </button>
          <h3>{t("Cancel Transaction")}</h3>
          <p>{t("Are you sure you want to cancel the transaction?")}</p>
          <div className="wrapper-buttons">
            <button
              onClick={closePopupCanceled}
              className="form-default__cancel"
            >
              {t("No")}
            </button>
            <button
              onClick={() => { handleCancel(); closePopupCanceled(); }}
              className="form-default__submit"
            >
              {t("Yes")}
            </button>
          </div>
        </div>
      </Popup>

      <Popup isOpen={isPopupOpenConfirm} onClose={closePopupConfirm}>
        <div className="view-details">
          <button onClick={closePopupConfirm} className="close-popup">
            <i className="ri-close-line"></i>
          </button>
          <h3>{t("Confirm Payment")}</h3>
          <p>{t("Are you sure you want to confirm Exchange transaction?")}</p>
          <div className="wrapper-buttons">
            <button onClick={closePopupConfirm} className="form-default__cancel">
              {t("No")}
            </button>
            <button
              onClick={() => { handleConfirm(); closePopupConfirm(); }}
              className="form-default__submit"
            >
              {t("Yes")}
            </button>
          </div>
        </div>
      </Popup>

      <ViewDetails chatData={chatData} setIsPopupOpenView={setIsPopupOpenView} isPopupOpenView={isPopupOpenView} invoice={invoice} handleConfirm={() => setIsPopupOpenConfirm(true)} status={status} userType={userInfo.type} buyWalletData={buyWalletData} interlocutorFName={interlocutorFName} interlocutorLName={interlocutorLName} />

      <h1><Link className="back-link" to="/transactions-list"><i className="ri-arrow-left-line"></i></Link> Exchange #{chatData.name.toUpperCase().slice(2)}</h1>
      <div {...getRootProps()} className="chat-container" style={{ height: `${533 + attachmentHeight + inputHeight}px` }}>
        <h2>{t("Chat")}</h2>
        <div className="chat-messages">
          {data && socket ? (
            data.map((item, index) => (
              <ChatItem
                key={index}
                current={userInfo.type === item.type}
                fname={
                  userInfo.type === item.type
                    ? userInfo.fname
                    : interlocutorFName
                }
                lname={
                  userInfo.type === item.type
                    ? userInfo.lname
                    : interlocutorLName
                }
                message={item.text}
                type={item.type}
                fileURL={item.fileURL}

              />
            ))
          ) : (
            <p className="chat-no-access">{t("Only the manager attached to the transaction has access to the chat")}</p>
          )}
        </div>
        {socket ? <form className="chat-input" onSubmit={handleSubmit}>
          <div className="chat-input__container">
            <button type="button" onClick={handleFile}>
              <i class="ri-attachment-2"></i>
            </button>
            <textarea
              ref={textareaRef}
              onKeyDown={hotKeys}
              placeholder={t("Send message...")}
              value={value}
              onChange={onChange}
              type="text"
              style={{ height: "24px" }}
            />
            <button>
              <i className="ri-send-plane-fill"></i>
            </button>
            <input {...getInputProps()} ref={hiddenFileInput} />
          </div>
          {files[0] ? <ul ref={attachmentRef} className="list-files">
            {files.map((file, index) => (
              <li onClick={() => deleteFile(index)} key={index}><i className="ri-close-line delete"></i> {checkFormatFile(file) === "image" ? <i class="ri-file-image-line default"></i> : <i class="ri-file-2-line default"></i>} {file.name.length > 12 ? `${file.name.slice(0, 12)}...` : file.name}</li>
            ))}
          </ul> : null
          }
        </form> : null

        }

      </div>

      <div className="chat-info">
        <h3>{t("Info")}</h3>
        <div className="chat-info__wrapper">
          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Status")}</p>
              {/* <p className="bot">Status text info</p> */}
            </div>
            <p className={`status ${changeStatus}`}>{changeStatus}</p>
          </div>

          {/* <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Timer")}</p>
            
            </div>
            <TimeDifference status={status} opened={chatData.opened} />
          </div> */}

          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Pay with")}</p>
            </div>
            <div className="wallet">

              {checkWalletsType(sellWalletData.curr) === "bank" ? (
                <div>
                  <h3>{userInfo.type === 0 ? userInfo.fname + " " + userInfo.lname : interlocutorFName + " " + interlocutorLName}</h3>
                  <p>{`${sellWalletData.curr.toUpperCase()} (${sellWalletData.type.toUpperCase()}) ${t(
                    "ending in"
                  )} ${sellWalletData.iban.slice(-4)}`}</p>
                </div>
              ) : (
                <div>
                  <h3>{sellWalletData.name}</h3>
                  <p>{`${convertTRCIdentifiers(sellWalletData.curr.toUpperCase())} ${convertTRCIdentifiers(sellWalletData.type.toUpperCase())} ${t(
                    "ending in"
                  )} ${sellWalletData.num.slice(-4)}`}</p>
                </div>
              )}
            </div>
          </div>

          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Receive on")}</p>
            </div>
            <div className="wallet">
              {checkWalletsType(buyWalletData.curr) === "bank" ? (
                <div>
                  <h3>{userInfo.type === 0 ? userInfo.fname + " " + userInfo.lname : interlocutorFName + " " + interlocutorLName}</h3>
                  <p>{`${buyWalletData.curr.toUpperCase()} (${buyWalletData.type.toUpperCase()}) ${t(
                    "ending in"
                  )} ${buyWalletData.iban.slice(-4)}`}</p>
                </div>
              ) : (
                <div>
                  <h3>{buyWalletData.name}</h3>
                  <p>{`${convertTRCIdentifiers(buyWalletData.curr.toUpperCase())} ${convertTRCIdentifiers(buyWalletData.type.toUpperCase())} ${t(
                    "ending in"
                  )} ${buyWalletData.num.slice(-4)}`}</p>
                </div>
              )}
            </div>
          </div>

          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Give (without fee)")}</p>
            </div>
            <div className="img">
              <img src={currencySellData.img} alt="" />
              <p>{chatData.sell_amount}</p>
            </div>
          </div>

          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Fee")}</p>
            </div>
            <div className="img">
              <img src={currencySellData.img} alt="" />
              <p>{chatData.fee}</p>
            </div>
          </div>

          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Total to be paid")}</p>
            </div>
            <div className="img">
              <img src={currencySellData.img} alt="" />
              <p>{parseFloat(chatData.fee) + parseFloat(chatData.sell_amount)}</p>
            </div>
          </div>


          <div className="line"></div>

          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Receive")}</p>
            </div>
            <div className="img">

              <img src={currencyBuyData.img} alt="" />
              <p>{chatData.buy_amount}</p>
            </div>
          </div>
          <div className="line"></div>
          <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Transfer info")}</p>
            </div>
            <button
              className="link-invoice"
              onClick={() => setIsPopupOpenView(true)}
            >
              <i className="ri-table-view"> </i>
              <p>{t("View")}</p>
            </button>
          </div>
          {userInfo.type === 1 ? <div className="line"></div> : null}
          {userInfo.type === 1 ? <div className="chat-info__wrapper-item">
            <div className="top-bot">
              <p className="top">{t("Client info")}</p>
            </div>
            <Link
              className="link-invoice"
              to={`/client/${chatData.user}`}
              target="_blank"
            >
              <i class="ri-user-search-line"></i>
              <p>{t("Open")}</p>
            </Link>
          </div> : null}
        </div>
      </div>
      <div
        style={
          ((status >= 0 && status < 2 && userInfo.type === 0) ||
            (status > 0 && status <= 2 && userInfo.type === 1)) && socket
            ? { opacity: "1" }
            : { opacity: "0" }
        }
        className="form-confirm"
      >
        <h3
          style={
            ((status >= 0 && status < 2 && userInfo.type === 0) ||
              (status > 0 && status <= 2 && userInfo.type === 1)) && socket
              ? { cursor: "pointer" }
              : { cursor: "default" }
          }
        >
          {t("Confirm Payment")}
        </h3>
        {userInfo.type === 0 ? (
          <p
            style={
              ((status >= 0 && status < 3 && userInfo.type === 0) ||
                (status > 0 && status <= 2 && userInfo.type === 1)) && socket
                ? { cursor: "pointer" }
                : { cursor: "default" }
            }
          >
            {t(
              "Confirm that you have sent the payment. Be careful, click strictly after sending"
            )}
          </p>
        ) : (
          <button
            style={
              ((status >= 0 && status < 2 && userInfo.type === 0) ||
                (status > 0 && status <= 2 && userInfo.type === 1)) && socket
                ? { cursor: "pointer" }
                : { cursor: "default" }
            }
            onClick={() => setIsPopupOpenCanceled(true)}
            className="form-default__cancel"
          >
            {t("Cancel")}
          </button>
        )}

        <button
          style={
            ((status >= 0 && status < 2 && userInfo.type === 0) ||
              (status > 0 && status <= 2 && userInfo.type === 1)) && socket
              ? { cursor: "pointer", display: "block" }
              : { cursor: "default", display: "none" }
          }
          className="form-default__submit"
          onClick={() => setIsPopupOpenConfirm(true)}
          type="submit"
        >
          {userInfo.type === 0 ? t("I’ve Proceed the Payment") : t("Confirm")}
        </button>
      </div>
    </div>
  );
};

export default Chat;
